import $apiJSON from '../http/apiJSON'

// Donations API Service

// Categories
export async function getDonationCategories(params = {}) {
  return $apiJSON.get('donats/categories/', { params })
}

export async function getDonationCategory(id) {
  return $apiJSON.get(`donats/categories/${id}/`)
}

export async function getDonationCategoryProducts(id) {
  return $apiJSON.get(`donats/categories/${id}/products/`)
}

// Products
export async function getDonationProducts(params = {}) {
  return $apiJSON.get('donats/products/', { params })
}

export async function getDonationProduct(id) {
  return $apiJSON.get(`donats/products/${id}/`)
}

// Orders
export async function getDonationOrders(params = {}) {
  return $apiJSON.get('donats/orders/', { params })
}

export async function getDonationOrder(id) {
  return $apiJSON.get(`donats/orders/${id}/`)
}

export async function checkDonationOrderStatus(id) {
  return $apiJSON.get(`donats/orders/${id}/check_status/`)
}

export async function createDirectOrder(data) {
  return $apiJSON.post('donats/orders/create_direct/', data)
}

export async function createVoucherOrder(data) {
  return $apiJSON.post('donats/orders/create_voucher/', data)
}

export async function createSteamOrder(data) {
  return $apiJSON.post('donats/orders/create_steam/', data)
}

// Validation
export async function validateUserAccount(data) {
  return $apiJSON.post('donats/validate/', data)
}

// History
export async function getDonationHistory(params = {}) {
  return $apiJSON.get('donats/history/', { params })
}

// Balance (admin only)
export async function getGemgemBalance() {
  return $apiJSON.get('donats/balance/')
}

// Sync catalog (admin only)
export async function syncDonationCatalog(data) {
  return $apiJSON.post('donats/categories/sync/', data)
}

export async function syncCategoryProducts(categoryId) {
  return $apiJSON.post('donats/products/sync_category/', { category_id: categoryId })
}

// Default export объекта со всеми функциями
const DonationService = {
  getDonationCategories,
  getDonationCategory,
  getDonationCategoryProducts,
  getDonationProducts,
  getDonationProduct,
  getDonationOrders,
  getDonationOrder,
  checkDonationOrderStatus,
  createDirectOrder,
  createVoucherOrder,
  createSteamOrder,
  validateUserAccount,
  getDonationHistory,
  getGemgemBalance,
  syncDonationCatalog,
  syncCategoryProducts
}

export default DonationService
